import { LoadingStates } from '@pb/utils'

import PointsHistoryState from './types'

const initialState: PointsHistoryState = {
  transactionsAfterReset: [],
  resetTransaction: undefined,
  transactionsBeforeReset: [],
  totalNumberOfTransactions: 0,
  pointsOverviewSectionOrders: {},
  loadingOrderStatus: LoadingStates.NotLoaded,
  loadingPointsHistoryStatus: LoadingStates.NotLoaded,
}

export default initialState
